/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/LicensingTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
/** @hidden */
export const LicenseStatusValues = [
    'OKAY',
    'TRIAL',
    'OKAY_EXPIRING_SOON',
    'FAILURE_NOT_SET',
    'FAILURE_CORRUPTED',
    'FAILURE_WRONG_OS',
    'FAILURE_APP_ID_MISMATCH',
    'FAILURE_EXPIRED',
    'FAILURE_SERVER',
    'FAILURE_VERSION',
    'FAILURE_INACTIVE',
];
/**
Description of error that occurred during device deregistration.
*/
export class DeviceDeregistrationError {
    /** @param source {@displayType `DeepPartial<DeviceDeregistrationError>`} */
    constructor(source = {}) {
        if (source.deviceId !== undefined) {
            this.deviceId = source.deviceId;
        }
        else {
            throw new Error('deviceId must be present in constructor argument');
        }
        if (source.errorMessage !== undefined) {
            this.errorMessage = source.errorMessage;
        }
        else {
            throw new Error('errorMessage must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            deviceId: this.deviceId,
            errorMessage: this.errorMessage,
        };
    }
}
/**
Information about the SDK license.
*/
export class LicenseInfo {
    /** @param source {@displayType `DeepPartial<LicenseInfo>`} */
    constructor(source = {}) {
        /**
          Number of devices the license is valid for, if the license is floating.
          */
        this.devices = null;
        if (source.status !== undefined) {
            this.status = source.status;
        }
        else {
            throw new Error('status must be present in constructor argument');
        }
        if (source.isValid !== undefined) {
            this.isValid = source.isValid;
        }
        else {
            throw new Error('isValid must be present in constructor argument');
        }
        if (source.licenseStatusMessage !== undefined) {
            this.licenseStatusMessage = source.licenseStatusMessage;
        }
        else {
            throw new Error('licenseStatusMessage must be present in constructor argument');
        }
        if (source.expirationTimestamp !== undefined) {
            this.expirationTimestamp = source.expirationTimestamp;
        }
        else {
            throw new Error('expirationTimestamp must be present in constructor argument');
        }
        if (source.expirationDateString !== undefined) {
            this.expirationDateString = source.expirationDateString;
        }
        else {
            throw new Error('expirationDateString must be present in constructor argument');
        }
        if (source.errorMessage !== undefined) {
            this.errorMessage = source.errorMessage;
        }
        else {
            throw new Error('errorMessage must be present in constructor argument');
        }
        if (source.onlineLicenseCheckInProgress !== undefined) {
            this.onlineLicenseCheckInProgress = source.onlineLicenseCheckInProgress;
        }
        else {
            throw new Error('onlineLicenseCheckInProgress must be present in constructor argument');
        }
        if (source.license !== undefined) {
            this.license = source.license;
        }
        else {
            throw new Error('license must be present in constructor argument');
        }
        if (source.devices !== undefined) {
            this.devices = source.devices != null ? source.devices : null;
        }
        if (source.nextOnlineLicenseCheckInMs !== undefined) {
            this.nextOnlineLicenseCheckInMs = source.nextOnlineLicenseCheckInMs;
        }
        else {
            throw new Error('nextOnlineLicenseCheckInMs must be present in constructor argument');
        }
        if (source.deviceDeregistationErrors !== undefined) {
            this.deviceDeregistationErrors = source.deviceDeregistationErrors.map((it) => {
                return new DeviceDeregistrationError(it);
            });
        }
        else {
            throw new Error('deviceDeregistationErrors must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            status: this.status,
            isValid: this.isValid,
            licenseStatusMessage: this.licenseStatusMessage,
            expirationTimestamp: this.expirationTimestamp,
            expirationDateString: this.expirationDateString,
            errorMessage: this.errorMessage,
            onlineLicenseCheckInProgress: this.onlineLicenseCheckInProgress,
            license: this.license,
            devices: this.devices != null ? this.devices : null,
            nextOnlineLicenseCheckInMs: this.nextOnlineLicenseCheckInMs,
            deviceDeregistationErrors: this.deviceDeregistationErrors.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/** @hidden */
export const FeatureValues = [
    'BARCODE_SCANNER',
    'CHECK_SCANNER',
    'CREDIT_CARD_SCANNER',
    'IMAGE_PROCESSING',
    'DOCUMENT_SCANNER',
    'LICENSE_PLATE_SCANNER',
    'MEDICAL_CERTIFICATE_SCANNER',
    'MRZ_SCANNER',
    'OCR',
    'TEXT_PATTERN_SCANNER',
    'PDF_CREATION',
    'ID_CARD_SCANNER',
    'DRIVER_LICENSE_SCANNER',
    'EHIC_SCANNER',
    'DOCUMENT_CLASSIFICATION',
    'DOCUMENT_QUALITY_ANALYZER_CONFIGURATOR',
];
//# sourceMappingURL=LicensingTypes.js.map